import React, { useState, useEffect } from "react";
import {
  Warning,
  CheckboxSelector,
  Button,
  ErrorMsg

} from "@onegovbugs/onegov-react-components";
import Select from "react-select";
import styles from "./collectionOfLicence.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { storeCollectionOfLicence, saveApplication, getServiceCentres } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import { isSelected, validate, scrollToError } from "../../utils/Validation";
import { RedirectIfCaptchaNotSelected, RedirectIfPrerequisitesNotSelected } from "../../utils/redirect";
import ScrollToTop from "../../utils/scrollToTop";
import { TATTOO_OPERATOR_FORM } from "../../constants";

const Declaration = props => {
  RedirectIfCaptchaNotSelected(props);
  RedirectIfPrerequisitesNotSelected(props);
  ScrollToTop();

  const dispatch = useDispatch();
  const form = useSelector(state => state.form);
  const collectionOfLicence = useSelector(state => state.collectionOfLicence);
  const [centreLocation, setCentreLocation] = useState(
    collectionOfLicence ? collectionOfLicence.centreLocation : null
  );


  const [showErrors, setShowErrors] = useState(false);

  useEffect(
    () => {
      validate(validators, setErrors);
    },
    [centreLocation]
  );

  useEffect(
    () => {
      dispatch(getServiceCentres());
    },
    [dispatch]
  );

  const storeData = (finished) => {
    dispatch(
      storeCollectionOfLicence({
        centreLocation,
        finished,
        step: form.form === 'operator' ? 1 : "step4"
      })
    );
  };

  const validators = [
    {
      fieldName: "centreLocation",
      fieldValue: centreLocation,
      isValid: v => isSelected(v)
    }
  ];

  const [errors, setErrors] = useState({
    centreLocation: false
  });

  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12"}>
          <p>
            You must provide the location of the Motor Registry from which you
            intend to collect your Licence.
          </p>
          <p>
            A list of Motor Registries, their addresses and Opening Hours can be
            obtained from the RMS Website{" "}
            <a target="_blank" href="http://www.rms.nsw.gov.au">
              http://www.rms.nsw.gov.au
            </a>.
          </p>
          <p>
            Enter the name of the location exactly as it is listed in the RMS
            Website. Eg "St Marys" "Wetherill Park".
          </p>
          <p>
            Note - Your licence can only be collected from a Motor Registry. You
            cannot nominate "agencies" or "Government Access Centres (GACs)."
          </p>
          <p>
            If a licence is granted it must be collected from the nominated
            registry within 60 days. Fair Trading will write to you to advise
            you when the licence can be collected.
          </p>
          <p>
            If the licence is not collected within 60 days of notification, it
            will be cancelled
          </p>
        </div>
      </div>
      <div className={"row"}>
        <div className="col-12 col-sm-6">
          <label htmlFor={"selectServiceCentres"}>
            Select service centre location
          </label>
          <Select
            id="selectServiceCentres"
            defaultValue={centreLocation}
            onChange={setCentreLocation}
            className={styles.select}
            options={collectionOfLicence.serviceCentres}
          />
        </div>
      </div>
      {errors.centreLocation && showErrors ? (
        <div className={"row"}>
          <div className={`col-6 ${styles.errorContainer}`}>
            <ErrorMsg className={"ErrorMsg_error"}
              type={"error"}
              description={"Please make a selection."}
            />
          </div>
        </div>
      ) : null}

      <div className={`row ` + styles.topMargin128}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                setShowErrors(false);
                storeData(true);
                { form.form === 'operator' ? props.history.push(`./dashboard`) : props.history.push(`./proof-of-identity`) }
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            {form.form === 'operator' ? 'Complete' : 'Continue'}
          </Button>
          <Button
            secondary
            onClick={() => {
              storeData(false);
              dispatch(
                saveApplication(form.form === 'operator' ? 1 : "step4", () => {
                  {
                    form.form === TATTOO_OPERATOR_FORM ?
                      props.history.push(`./dashboard`) :
                      window.location.href = `${process.env.REACT_APP_BAU_URL}`
                  }
                })
              );
            }}
          >
            Save & exit section
        </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(props => <Declaration {...props} />);
